import { SET_SHIPPER_HASH } from "../Type";

export const setShiper = (args) => {
  return {
    type: SET_SHIPPER_HASH,
    args,
  };
};
